import React, {
  type CSSProperties,
  type FC,
  type ReactNode,
  useEffect,
  useState,
} from 'react'
import clsx from 'clsx'
import styles from './progressline.scss'

const PERCENT100 = 100

export type ProgressLineProps = {
  progress: number
  message: ReactNode | string
  className?: string
  classNameProgress?: string
}

export const ProgressLine: FC<ProgressLineProps> = (props) => {
  const {progress, message, className, classNameProgress} = props
  const [style, setStyle] = useState<CSSProperties>({transform: `scale(0, 1)`})

  useEffect(() => {
    const normaizeProgress = progress/PERCENT100

    setTimeout(() => {
      setStyle({transform: `scale(${normaizeProgress}, 1)`})
    }, 300)
  }, [progress])

  const isTextMessage = typeof message === 'string'

  return (
    <div className={clsx(styles.wrap, className)}>
      <div className={clsx(styles.progress, classNameProgress)} style={style} />
      {message && (
        <div className={clsx(styles.message, isTextMessage && styles.textMessage)}>
          {message}
        </div>
      )}
    </div>
  )
}
